<template>
    <el-form-item class="form-actions">
        <el-button type="primary" size="large" class="submit-btn" @click="$emit('submit')" :loading="loading">
            <el-icon class="btn-icon">
                <Check />
            </el-icon>
            保存配置
        </el-button>
        <el-button type="info" size="large" class="reset-btn" @click="handleReset">
            <el-icon class="btn-icon">
                <Refresh />
            </el-icon>
            重置表单
        </el-button>
    </el-form-item>
</template>

<script>
import { Check, Refresh } from '@element-plus/icons-vue'

export default {
    name: 'FormActions',
    components: {
        Check,
        Refresh
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        cloudType: {
            type: String,
            default: 'aliyun'
        }
    },
    emits: ['submit', 'reset'],
    methods: {
        handleReset() {
            this.$confirm('请选择重置方式：', '重置配置', {
                confirmButtonText: '清空表单',
                cancelButtonText: '恢复默认',
                distinguishCancelAndClose: true,
                type: 'warning'
            }).then(() => {
                this.$emit('reset', this.cloudType, 'clear');
            }).catch((action) => {
                if (action === 'cancel') {
                    this.$emit('reset', this.cloudType, 'default');
                }
            });
        }
    }
}
</script>

<style scoped>
.form-actions {
    margin-top: 40px;
    text-align: center;
}

.submit-btn,
.reset-btn {
    width: 160px;
    padding: 14px 24px;
    font-size: 15px;
    letter-spacing: 0.5px;
}

.btn-icon {
    margin-right: 8px;
    font-size: 16px;
}
</style>